<template>
	<div v-if="user_load" class="cmbc_list bg_FFFFFF">
		<naviBack type='list2' title="comt" background="#FFFFFF" @filterToSearch="filterToSearch"
			:search_params="search_params" />
		<div v-if="is_load" class="width_100 cmbc_list_body">
			<div v-if="total_list.length>0">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="nextPage" offset="30">
					<list1 :list="total_list" />
				</van-list>
			</div>
			<div v-if="total_list.length==0">
				<empty />
			</div>
		</div>
	</div>
</template>

<script>
	
	import naviBack from '../components/navi_back.vue';
	import list1 from '../components/list_1.vue';
	import empty from '../components/empty.vue';
	import {
		getVenueServiceList,login
	} from '../api/api.js'
	export default {
		components: {
			naviBack,
			list1,
			empty
		},
		name: "",
		data() {
			return {
				user_load:false,
				city_list: [], //城市列表

				is_load: false,
				loading: true, //是否处于加载状态，加载过程中不触发load事件
				finished: false, //是否已加载完成，加载完成后不再触发load事件
				page: 1,
				page_size: 20,
				total_list: [],

				search_params: null, //搜索参数
			};
		},
		mounted() {
			this.$RCLoading.show();
			this.initUser()
			console.log(this.$route);
			// alert(JSON.stringify(this.$route.query))
			
		},
		methods: {
			async initUser(){
				var $this = this
				console.log(this.$route.query);
				try {
					var res=await login(this.$route.query)
					console.log(res);
					if(res.data && res.data.token && res.data.token.token){
						$this.$RCLoading.hide();
						sessionStorage.setItem('token',res.data.token.token)
						setTimeout(()=>{
							$this.user_load=true
						},50)
					}else{
						$this.$RCLoading.hide();
						$this.$toast('用户信息解析失败，请联系管理人员')
					}
				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			},
			// 获取页面列表
			getPageListBefore() {
				this.is_load = false
				this.loading = true
				this.finished = false
				this.page = 1
				this.getPageList()
			},
			async getPageList() {
				var $this = this
				// // console.log('getPageList', this.search_params);
				var params = {
					cityId: this.search_params.city_id,
					keyword: this.search_params.key_words,
					districtId: this.search_params.district_id,
					page: this.page,
					pageSize: this.page_size,
				}
				try {
					var res = await getVenueServiceList(params)
					// console.log(res);
					var list = res.data
					// // console.log(list);
					if ($this.page == 1) {
						$this.total_list = list
						$this.loading = false
						$this.finished = $this.total_list.length < $this.page_size ? true : false
						$this.is_load = true
					} else {
						if (list.length == 0) {
							// $this.total_list = [...$this.total_list, ...list]
							$this.loading = false
							$this.finished = true
							$this.is_load = true
						} else {
							$this.total_list = [...$this.total_list, ...list]
							$this.loading = false
							$this.finished = $this.total_list.length < $this.page_size ? true : false
							$this.is_load = true
						}
					}
					$this.$RCLoading.hide();

				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			},
			// 加载下一页
			nextPage() {
				// // console.log('加载下一页');
				if (this.finished) {
					return
				}
				this.$RCLoading.show();
				this.loading = true
				this.page = this.page + 1
				this.getPageList()
			},
			// 过滤+搜索
			filterToSearch(e) {
				// console.log(e);

				this.search_params = e
				this.$RCLoading.show();
				this.getPageListBefore()
			}
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750 * 100vw;

	.cmbc_list {
		min-height: 100vh;

		.cmbc_list_body {
			padding: 2*@vm_base 30*@vm_base 30*@vm_base 30*@vm_base;
			padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 30*@vm_base);
			padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/list.vue